import { render } from "./displayMethod.vue?vue&type=template&id=99f584f0&scoped=true"
import script from "./displayMethod.vue?vue&type=script&lang=js"
export * from "./displayMethod.vue?vue&type=script&lang=js"

import "./displayMethod.vue?vue&type=style&index=0&id=99f584f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f584f0"]])

export default __exports__